
const formatDatetimeLocal = (dateStr) => {
  const date    = new Date(dateStr);
  const year    = date.getFullYear();
  const month   = String(date.getMonth() + 1).padStart(2, '0');
  const day     = String(date.getDate()).padStart(2, '0');
  const hours   = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}



export const terapiasMapper = (dataTerapia) => {

  const dataCita     = dataTerapia.consultamedica.cita;
  const dataDoctor   = dataCita.doctor.idPersona;
  const dataPaciente = dataCita.paciente.persona;

  
  let titulares = []

  try {
    let detalles_cita = dataCita.detallescitaSet
    let json_titulares = JSON.parse(detalles_cita[0].detallesTitulares)
    titulares = json_titulares
  } catch (error) { console.log("error en el parseo de json_titulares", error) }

  const fechaProgramada = dataTerapia.fechaProgramada 
    ? formatDatetimeLocal(dataTerapia.fechaProgramada)
    : '';

  const fechaProgramadaStr = fechaProgramada.replace('T', ' ');

  let sesionesValidas = 0


  let coberturasSubidas = 0


  if (dataTerapia.detallesTerapia && dataTerapia.detallesTerapia.length > 0){
   
    dataTerapia.detallesTerapia.forEach(element => {
      let cobSubidas = 0;
      if (element.estado === '1') { 
        console.log(element)
        if (element.estadoSesion && element.estadoSesion !== 'pendiente') {
          sesionesValidas = sesionesValidas + 1
        }
       
        if(element.urlMspPaciente) {cobSubidas = cobSubidas + 1 }
        if(element.urlMspTitular1) {cobSubidas = cobSubidas + 1 }
        if(element.urlMspTitular2) {cobSubidas = cobSubidas + 1 }
        if(element.urlMspTitular3) {cobSubidas = cobSubidas + 1 }

        if(cobSubidas !== 0 && cobSubidas === titulares.length ) {
          coberturasSubidas = coberturasSubidas + 1
        }
        if (titulares.length === 0 && cobSubidas > 0 ) {
          coberturasSubidas = coberturasSubidas + 1
        }


      
      }

      
    
  
    });
  }

  const sesionesProcesadas = `${sesionesValidas}/${dataTerapia.cantidad}`

  return {
    token           : dataTerapia.token,
    establecimiento : dataCita.establecimiento.Descripcion,
    paciente        : `${dataPaciente.identificacion} - ${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`,
    doctor          : `${dataDoctor.primerApellido} ${dataDoctor.primerNombre}`,
    terapia         : `${dataTerapia.terapia.codigo} - ${dataTerapia.terapia.nombre}`,
    terapiaDetalles : dataTerapia.terapia,
    numeroOrden     : dataTerapia.numeroOrdenAs400,
    cantidad        : dataTerapia.cantidad,
    estadoTerapia   : dataTerapia.estadoTerapia,
    tipoCobertura   : dataCita.cobSeleccionada,
    motivoTerapia   : dataTerapia.motivoSolicitud,
    resumenClinico  : dataTerapia.resumenClinico,
    sesionesProcesadas,
    coberturasSubidas,
    fechaProgramada : fechaProgramada,
    fechaProgramadaStr,
    fechaCita       : dataCita.fechaCita
  }
}

